import {CycleStatusType, ICycle, IEditCycle, IStation, IStationUser, StationStatusType} from '@core/api/data-access';
import {CycleModel} from '@cycles/data-access';

export namespace CycleModelExtensionsUtils {
	/**
	 * @description Returns the ids of all the users that are assigned to the cycle.
	 * @return {string[]}
	 */
	export function allCycleUsersIds(cycle: CycleModel): string[] {
		return cycle.stations?.map(station => station.getAllUserIds())?.flat() ?? [];
	}

	export function checkUserCanSignInFutureStation(cycle: ICycle, userId: string): boolean {
		const canSignFutureStations: IStation[] = cycle.stations.filter(station => station.status === StationStatusType.Waiting && station.users.some(user => user.user === userId));
		return canSignFutureStations.length > 0;
	}

	// Helper function to check if a station contains a user with the given userId
	export function stationContainsUser(station: IStation, userId: string): boolean {
		return station.users.some((user: IStationUser) => user.user === userId);
	}

	/**
	 * @description Validates the cycle fields.
	 * - for all new fields, generate new index;
	 * @param editCycle
	 */
	export function validateEditCycleFields<C extends IEditCycle>(editCycle: C): C {
		// validate fields indexes
		const fields = editCycle.fields;

		const fieldsWithoutIndex = fields.filter(field => !field.index);
		const fieldsWithIndex = fields.filter(field => field.index);

		// if there are fields without index, generate new indexes for them
		if (fieldsWithoutIndex.length > 0) {
			const maxIndex = fieldsWithIndex.reduce((maxIndex, field) => Math.max(maxIndex, field.index), 0);
			fieldsWithoutIndex.forEach((field, index) => (field.index = maxIndex + index + 1));
		}

		return editCycle;
	}

	/* -------------------------------------------------- Sign -------------------------------------------------- */
	export function checkUserCanSign(cycle: ICycle, userId: string): boolean {
		const userInCurrentStation = cycle.stations?.find((station: IStation) => station.status == StationStatusType.InProcess && station.users.some((user: IStationUser) => user.user === userId));
		return cycle.status === CycleStatusType.Cycling && userInCurrentStation != null;
	}

	export function checkUserRejectedCycle(cycle: ICycle, userId: string): boolean {
		//check for for the active user if he rejected the cycle on one of the stations
		const userRejectedCycle = cycle.stations.some((station: IStation) => station.users.some((user: IStationUser) => user.user === userId && user.status === StationStatusType.Rejected));
		return cycle.status === CycleStatusType.Denied && userRejectedCycle;
	}

	export function checkUserAlertedCycle(cycle: ICycle, userId: string): boolean {
		//check for for the active user if he alerted the cycle on one of the stations
		const userAlertedCycle = cycle.stations.some((station: IStation) => station.users.some((user: IStationUser) => user.user === userId && user.status === StationStatusType.Alert));
		return cycle.status === CycleStatusType.Completed && userAlertedCycle;
	}

	export function checkUserTimeoutCycle(cycle: ICycle, userId: string): boolean {
		//check for for the active user if he timeout the cycle on one of the stations
		const userTimeoutCycle = cycle.stations.some((station: IStation) => station.users.some((user: IStationUser) => user.user === userId && user.status === StationStatusType.TimedOut));
		return cycle.status === CycleStatusType.Canceled && userTimeoutCycle;
	}
}
